import { render, staticRenderFns } from "./StaticSectionWord.vue?vue&type=template&id=7137fa34"
import script from "./StaticSectionWord.vue?vue&type=script&lang=js"
export * from "./StaticSectionWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports